import React, {ReactNode, useState} from 'react'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {FlexGrowContent, RowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Collapse} from '@mui/material'
import {ExpandButton} from './CommonStyle'

interface Props {
    summary: ReactNode
    details: ReactNode
    children?: never
}

const CollapseContainer: React.FC<Props> = props => {
    const [open, setOpen] = useState(false)
    return (<>
        <RowFlexContainer onClick={() => setOpen(!open)}>
            <FlexGrowContent>
                {props.summary}
            </FlexGrowContent>
            <BlockSpacer width={'10px'}/>
            <ExpandButton open={open}/>
        </RowFlexContainer>
        <Collapse in={open}>
            <RowFlexContainer>
                <FlexGrowContent>
                    {props.details}
                </FlexGrowContent>
                <BlockSpacer width={'34px'}/>
            </RowFlexContainer>
        </Collapse>
    </>)
}

CollapseContainer.displayName = 'CollapseContainer'
export default CollapseContainer
